import { Component, HostBinding, ChangeDetectionStrategy, Input } from '@angular/core';
import { UiStateService } from '../../services/ui-state.service';

@Component({
    selector: 'eui-card-header',
    templateUrl: './eui-card-header.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EuiCardHeaderComponent {
    @Input() avatarUrl: string;
    @Input() expandLabel = 'expand';
    @Input() collapseLabel = 'collapse';
    @Input() iconClass: string;
    @Input() avatarDerscription = 'eUI card header avatar';
    @Input() iconDescription = 'eUI card header icon';
    @Input() isHeaderBodyOnly = false;  // TO BE DEPRECATED
    @Input() hasHeaderClickToggle = true;

    @HostBinding('class') string = 'eui-card-header';

    constructor( public uiStateService: UiStateService ) {
    }

    public onToggle(event: Event) {
        this.uiStateService.toggleCollapsed();
        this._preventDefault(event);
    }

    public onToggleHeader(event: Event) {
        if (this.hasHeaderClickToggle && this.uiStateService.state.isCollapsible) {
            this.uiStateService.toggleCollapsed();
        }
    }

    private _preventDefault(event: Event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
            event.cancelBubble = true;
        }
        return;
    }
}
